import { Component ,OnInit} from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TopNavBar } from '../top-nav-bar/top-nav-bar';

@Component({
  selector: 'app-main-layout',
  imports: [RouterModule , TopNavBar],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss'
})
export class MainLayout implements OnInit  {
  constructor(private route :ActivatedRoute , private router :Router) {}
 ngOnInit(): void {}
}
